import React from 'react';
import IsAcademyPublicContext from '../contextProviders/IsAcademyPublicContext';

export default function IsAcademyPublic(Component) {
  const C = props => {
    const { wrappedComponentRef, ...remainingProps } = props;

    return (
      <IsAcademyPublicContext.Consumer>
        {hasAcademyHeader => (
          <Component
            hasAcademyHeader={hasAcademyHeader}
            {...remainingProps}
            ref={wrappedComponentRef}
            wrappedComponentRef={wrappedComponentRef}
          />
        )}
      </IsAcademyPublicContext.Consumer>
    );
  };

  C.displayName = `IsAcademyPublic(${Component.displayName || Component.name})`;
  C.WrappedComponent = Component;

  return C;
}
